import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import { FieldViewType } from "../viewType";
import fieldsDictionary from "../fieldsDictionary";
import LinkFieldDetail from "./detail";
import LinkFieldEdit from "./edit";
import LinkFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type link en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function Link() {
    return _jsx(_Fragment, { children: "Link" });
}
var field = fieldsType.link || fieldsType.url;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, LinkFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, LinkFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, LinkFieldList);
